module.exports = __webpack_public_path__ + "static/media/footer.b9f3b71e.png";